import { render } from "./RegistrationPanel.vue?vue&type=template&id=4bdbf8ee&scoped=true"
import script from "./RegistrationPanel.vue?vue&type=script&lang=ts"
export * from "./RegistrationPanel.vue?vue&type=script&lang=ts"

import "./RegistrationPanel.vue?vue&type=style&index=0&id=4bdbf8ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4bdbf8ee"

export default script